import React from 'react';
import styled from 'styled-components';
import { CardWrapper } from '../styled/TrainerStyled';
import { NoKeywords as NoKeywordsIcon } from '../../common/icons/icons';
import colors from '../../../utils/colors';

const Message = styled.div`
    font-size: 14px;
    color: ${colors.gray.dark};
    line-height: 1.4;
`;

interface LocalizationLike {
    getText: (key: string) => string;
}

export function NoKeywordsCard(props: { localization: LocalizationLike }) {
    const { localization } = props;

    return (
        <CardWrapper>
            <NoKeywordsIcon style={{ margin: '25px auto 23px', display: 'block' }} />
            <Message>{localization.getText(`trainer.asr_config_errors.no_keywords`)}</Message>
        </CardWrapper>
    );
}
